import type { AuthDeniedReason } from 'boot/axiosAuthDeniedReason';

import { reactive } from 'vue';

import { PhoneCallGateway } from 'components/phoneCall/phoneCallGateway/PhoneCallGateway';

import { EventBus } from 'src/util/eventBus/EventBus';
import { PongConfiguration } from 'src/util/socket/types/PongConfiguration';

export interface LoadingState {
	activeSince: Date;
	requestId: string;
}

export type BootHealth = 'authLost' | 'ok' | 'pongFailed';

interface SimpleObservableStoreInterface {
	authDeniedReason: AuthDeniedReason | null;
	bootHealth: BootHealth;
	cleanExpiredRequests: () => void;
	phoneCallGateway: PhoneCallGateway | null;
	registration: ServiceWorkerRegistration | null;
	runningRequest: Array<LoadingState>;
	showAppUpdatedBanner: boolean;
	showToolbarLoadingIndicator: () => boolean;
	showVersionMismatch: boolean;
	usesRolloutCompatibleLegacyBackend: boolean;
}

interface GlobalStateInterface {
	authToken: string;
	csrfToken: string;
	eventBus: EventBus | null;
	pongConfiguration: PongConfiguration | null;
}

export const globalState: GlobalStateInterface = {
	authToken: '',
	csrfToken: '',
	eventBus: null,
	pongConfiguration: null,
};

export const simpleObservableStore: SimpleObservableStoreInterface = reactive({
	authDeniedReason: null,
	bootHealth: 'ok',
	cleanExpiredRequests: () => {
		simpleObservableStore.runningRequest = simpleObservableStore.runningRequest.filter((request) => {
			return (new Date().getTime() - request.activeSince.getTime()) / 1000 <= 300;
		});
	},
	phoneCallGateway: null,
	registration: null,
	runningRequest: [],
	showAppUpdatedBanner: false,
	showToolbarLoadingIndicator: () => {
		return simpleObservableStore.runningRequest.length > 0;
	},
	showVersionMismatch: false,
	usesRolloutCompatibleLegacyBackend: false,
});
